// Clamps a block's x/y (top-left, in inches) so its full box stays within
// the cell's usable-area bounds — used by both a block type's own drag math
// (e.g. TextBlockLayer) and the generic sidebar position edit
// (PrintableMasterGrid's PositionPanel wiring), so a block can never end up
// partly or fully outside the PRIMARY cell's border via either path. Also
// applied defensively at render time so a stale/out-of-range stored
// position (an old save, or a cell that shrank after rows/padding changed)
// can't render outside the border either.
export function clampToCellBounds(x, y, width, height, usableWidthIn, usableHeightIn) {
  const w = width || 0;
  const h = height || 0;
  const maxX = Math.max(0, usableWidthIn - w);
  const maxY = Math.max(0, usableHeightIn - h);
  return {
    x: Math.min(Math.max(0, x), maxX),
    y: Math.min(Math.max(0, y), maxY),
  };
}

// Clamps a block's width/height (in inches), anchored at its own x/y, so
// its box stays within the cell's usable-area bounds — the resize
// counterpart to clampToCellBounds above, used by resizable block types
// (e.g. ImageBlockLayer) during resize and defensively at render time,
// for the same reasons clampToCellBounds is.
const MIN_BLOCK_SIZE_IN = 0.1;
export function clampSizeToCellBounds(x, y, width, height, usableWidthIn, usableHeightIn) {
  const maxWidth = Math.max(MIN_BLOCK_SIZE_IN, usableWidthIn - x);
  const maxHeight = Math.max(MIN_BLOCK_SIZE_IN, usableHeightIn - y);
  return {
    width: Math.min(Math.max(MIN_BLOCK_SIZE_IN, width || 0), maxWidth),
    height: Math.min(Math.max(MIN_BLOCK_SIZE_IN, height || 0), maxHeight),
  };
}
